<bv-dialog [open]="open" (closed)="dismiss()">
  <bv-dialog-title>
    {{ titleKey | translate: { tier: (tier | translate) } }}
  </bv-dialog-title>

  <bv-dialog-body>
    {{ bodyKey | translate }}
  </bv-dialog-body>

  <bv-dialog-footer>
    <button bv-button variant="ghost" (click)="dismiss()">
      {{ 'CLOSE' | translate }}
    </button>
    <button bv-button variant="primary" (click)="goToCompare()">
      {{ 'COMPARE_PLANS' | translate }}
    </button>
  </bv-dialog-footer>
</bv-dialog>
